import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectImagePopupPage } from './select-image-popup';

@NgModule({
  declarations: [
    SelectImagePopupPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectImagePopupPage),
  ],
})
export class SelectImagePopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-image-popup/select-image-popup.module.ts